import * as React from 'react'

const CollapseIcon = (props: any) => {
  return (
    <svg {...props} width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.8978 5.69423L6.31005 0.121154C6.14651 -0.0403848 5.87394 -0.0403848 5.71039 0.121154L0.122658 5.69423C-0.0408859 5.85577 -0.0408859 6.125 0.122658 6.28654L0.722317 6.87885C0.88586 7.04038 1.15843 7.04038 1.32198 6.87885L5.71039 2.49038C5.87394 2.32885 6.14651 2.32885 6.31005 2.49038L10.6985 6.85192C10.862 7.01346 11.1346 7.01346 11.2981 6.85192L11.8978 6.25962C12.0341 6.09808 12.0341 5.85577 11.8978 5.69423Z'
        fill='#405264'
      />
    </svg>
  )
}

export default CollapseIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/CollapseIcon.tsx